import { projectStyledName } from 'shared/constants'

export const home = {
  review: 'Review',
  bc: 'New Pari Sportif',
  sportsBetting: 'Sports betting',
  liveBetting: 'Live betting',
  highlights: 'Highlights',
  liveCasino: 'Live casino',
  casino: 'Casino',
  sport: 'Sport',
  prematch: 'Prematch',
  liveSport: 'Live sport',
  welcomeBonus: 'Welcome bonus',
  depositBonus: '300% Deposit bonus',
  freespins: '130 Freespins',
  register: 'Register',
  bonusPromotions: 'Bonus promotions',
  vitrualGames: 'Virtual games',
  firecrash: 'Firecrash',
  newVirtuals: 'New virtuals',
  results: 'Results',
  search: 'Search',
  contact: 'Contact',
  settings: 'Settings',
  other: 'Other',
  auth: 'Auth',
  logOut: 'Log out',
  crash: 'Crash',
  evoAutoGames: 'Evo auto games',
  registration: 'Registration',
  signIn: 'Log in',
  bingo: 'Bingo',
  promotions: 'Promotions',
  allPromotions: 'All promotions',
  menu: 'Menu',
  deposit: 'Deposit',
  logout: 'Logout',
  firstSlideHomeText: `Join the BetGonzo circle of friends and get 200 Winspins, cash back up to $200 and a special
  surprise on Thursdays within a month of signing up!`,
  secondSlideHomeText: `Play online casino and get 20 risk free bingo cards! That's right, it's really that easy to try
  your luck!`,
  thirdSlideHomeText: 'Big jackpots and themed quizzes with prizes.',

  firstSlide2HomeText: `Join ${projectStyledName} now and receive the biggest no wagering bonus on your deposit`,
  secondSlide2HomeText: `Yes, that’s really easy and that’s every day`,
  thirdSlide2HomeText: 'Slots, live casino, sports betting and more',

  noWagering: 'NO WAGERING START-UP BONUS',
  everydayCashback: 'EVERYDAY CASHBACK',
  winBigWithGonzos: 'WIN BIG WITH GONZOS 100+ CRYPTOS',
  winBigWithGonzosMini: 'WIN BIG WITH GONZOS',
  joinNow: 'Join Now',
  largestBonus: 'Largest start-up bonus',
  luckyBonusBingo: 'Lucky bingo bonus',
  nightBingoParty: 'Night bingo party',
  learnMore: 'Learn more',
  moreDetail: 'More Detail',
}
